import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { ChangeEmailComponent } from '@app/user/pages/user-settings/change-email/change-email.component';
import { ChangePasswordComponent } from '@app/user/pages/user-settings/change-password/change-password.component';
import { ChangeUsernameComponent } from '@app/user/pages/user-settings/change-username/change-username.component';
import { UserSettingsComponent } from '@app/user/pages/user-settings/user-settings.component';
import { GlobalFooterComponent } from './components/global-footer/global-footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LeftSplitviewComponent } from './components/left-splitview/left-splitview.component';
import { SetNewPasswordComponent } from './components/set-new-password/set-new-password.component';
import { UnauthFooterComponent } from './components/unauth-footer/unauth-footer.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { EmailGotVerifiedComponent } from './pages/email-got-verified/email-got-verified.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LegalComponent } from './pages/legal/legal.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';

import { SelfserviceFooterComponent } from './components/selfservice-footer/selfservice-footer.component';
import { LoginComponent } from '@app/core/pages/login/login.component';
import { LoginCallbackComponent } from '@app/core/pages/login-callback/login-callback.component';
import { LoginRateLimitComponent } from '@app/core/pages/login-rate-limit/login-rate-limit.component';
import { ThirdPartyLicensesComponent } from './pages/third-party-licenses/third-party-licenses.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        MatFormFieldModule,
        MatDialogModule,
        HeaderComponent,
        UserProfileComponent,
        ChangePasswordComponent,
        GlobalFooterComponent,
        SelfserviceFooterComponent,
        LegalComponent,
        UnauthFooterComponent,
        ForgotPasswordComponent,
        PasswordResetComponent,
        LeftSplitviewComponent,
        UserSettingsComponent,
        ChangeUsernameComponent,
        ChangeEmailComponent,
        EmailGotVerifiedComponent,
        SetNewPasswordComponent,
        LoginComponent,
        LoginCallbackComponent,
        LoginRateLimitComponent,
        ThirdPartyLicensesComponent,
    ],
    exports: [
        HeaderComponent,
        GlobalFooterComponent,
        SelfserviceFooterComponent,
        UnauthFooterComponent,
        LegalComponent,
        ThirdPartyLicensesComponent,
    ],
})
export class CoreModule {}
